const language = {
	spanish: {
		header_title: "Motocicletas",
		motocicletas_yellow_title: "MOTOCICLETAS",
		motocicletas_bold_title:
			"Garantice la seguridad de su motocicleta con nuestro software de alta precisión. Algunas de las características son: Seguimiento en tiempo real, vigilancia en salas de monitoreo y alertas de emergencia ante robo.",
		motocicletas_bold_text:
			"Puede obtener un monitoreo constante sobre la ubicación, combustible y las condiciones en la que está operando su Motocicleta o flotas de estas.",
		motocicletas_text: [
			"Además, la colocación del dispositivo en la moto es discreta y segura. También, le permitimos configurar distintas alertas dependiendo de sus necesidades.",
			"A su vez, puedes disfrutar de múltiples beneficios como:",
		],
		beneficios_yellow_title: "BENEFICIOS",
		beneficios_list: [
			{
				text: "Reducir los costos de mantenimiento a través de alertas.",
				column: "1",
			},
			{
				text: "Ahorro general al monitorear los hábitos de manejo.",
				column: "1",
			},
			{
				text: "Rastreo en tiempo real desde una aplicación móvil o la web.",
				column: "1",
			},
			{
				text: "Alertas de uso del vehículo: excesos de velocidad, entrada y salidas de áreas de seguridad, botón de pánico, apagado remoto de motor.",
				column: "1",
			},
			{
				text: "Integración de múltiples sensores para mayor seguridad y personalización de necesidades.",
				column: "2",
			},
			{
				text: "Gestión de combustible.",
				column: "2",
			},
			{
				text: "Soporte 24/7.",
				column: "2",
			},
		],
		beneficio_1_bold_title: "Ubicación en tiempo real",
		beneficio_1_text:
			"Podrás tener la tranquilidad de saber dónde se encuentran sus motocicletas en todo momento a través de tu PC o smartphone.",
		beneficio_2_bold_title: "Uso de tu vehículo",
		beneficio_2_text:
			"Contarás con la recepción de alertas de exceso de velocidad, salidas y entradas a zonas preestablecidas, así como usos fuera de horario que te permitan generar medidas de prevención.",
		caracteristicas_yellow_title: "CARACTERÍSTICAS",
		caracteristicas_bold_title:
			"Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		caracteristicas_list: [
			{
				text: "Sistema de localización vía GPS y dispositivos móviles.",
				column: "1",
			},
			{
				text: "Generador de geocercas, puntos de interés y rutas.",
				column: "1",
			},
			{
				text: "Visibilidad de vehículos sobre mapas digitalizados y fotos satelitales (Google Maps y OSM).",
				column: "1",
			},
			{
				text: "Diversidad de reportes de gestión de conductores y uso de vehículos.",
				column: "1",
			},
			{
				text: "Programar envío recurrente de reportes.",
				column: "1",
			},
			{
				text: "Alertas en tiempo real de incidencias de seguridad y logística.",
				column: "1",
			},
			{
				text: "Apagado remoto del vehículo y detección de manipulación del dispositivo.",
				column: "2",
			},
			{
				text: "Manejo de distintos tipos de vehículos.",
				column: "2",
			},
			{
				text: "Disponibilidad de integración de varios dispositivos.",
				column: "2",
			},
			{
				text: "Gestión de horas de manejo por conductor.",
				column: "2",
			},
			{
				text: "Administración de usuarios por roles.",
				column: "2",
			},
		],
	},
	english: {
		header_title: "Motorcycles",
		motocicletas_yellow_title: "MOTORCYCLES",
		motocicletas_bold_title:
			"Ensure the security of your motorcycle with our high-precision software. Some of the features are: Real time tracking, monitoring room surveillance and emergency alerts in case of theft.",
		motocicletas_bold_text:
			"You can get constant monitoring of the location, fuel and conditions in which your motorcycle or fleet is operating.",
		motocicletas_text: [
			"In addition, the placement of the device in the motorcycle is discreet and secure. Also, we allow you to configure different alerts depending on your needs.",
			"At the same time, you can enjoy multiple benefits such as:",
		],
		beneficios_yellow_title: "BENEFITS",
		beneficios_list: [
			{
				text: "Reduce maintenance costs through alerts.",
				column: "1",
			},
			{
				text: "Overall savings by tracking driving habits.",
				column: "1",
			},
			{
				text: "Real time tracking from a mobile application or the web.",
				column: "1",
			},
			{
				text: "Vehicle usage alerts: speeding, entering, and exiting security areas, panic button, remote engine shutdown.",
				column: "1",
			},
			{
				text: "Integration of multiple sensors for greater security and customization needs.",
				column: "2",
			},
			{
				text: "Fuel management.",
				column: "2",
			},
			{
				text: "24/7 SUPPORT.",
				column: "2",
			},
		],
		beneficio_1_bold_title:
			"Know the location of your motorcycle in real time.",
		beneficio_1_text:
			"You can have peace of mind knowing where your motorcycle is always through your PC or smartphone.",
		beneficio_2_bold_title: "Know what use is given to your vehicle.",
		beneficio_2_text:
			"You will receive alerts for speeding, exiting pre-established areas, after hours use of the motorcycle, allowing you to take prevention measures.",
		caracteristicas_yellow_title: "FEATURES",
		caracteristicas_bold_title:
			"We have the best technological innovation for optimal tracking of your mobile assets:",
		caracteristicas_list: [
			{
				text: "Location system through GPS and mobile devices.",
				column: "1",
			},
			{
				text: "Addition of geofences, points of interests and routes.",
				column: "1",
			},
			{
				text: "Vehicle visibility on digital maps and satellite photos (Google Maps and OSM).",
				column: "1",
			},
			{
				text: "Variety of driver management and vehicle usage reports.",
				column: "1",
			},
			{
				text: "Schedule periodic reports.",
				column: "1",
			},
			{
				text: "Real time security and logistic incidents alerts.",
				column: "1",
			},
			{
				text: "Device tampering detection and remote vehicle shutdown.",
				column: "2",
			},
			{
				text: "Management of different types of vehicles.",
				column: "2",
			},
			{
				text: "Availability of multiple device integration.",
				column: "2",
			},
			{
				text: "Management of driving hours per driver.",
				column: "2",
			},
			{
				text: "User management by roles.",
				column: "2",
			},
		],
	},
};

export default language;